import React from 'react';
import DealsFiltersBar from '@/modules/deals/components/shared/DealsFiltersBar';

const ProposalFilters = ({
  filters,
  onSearchChange,
  onPriorityChange,
  onAssigneeChange,
  onStageChange,
  onClientChange,
  onClearFilters,
  assigneeOptions,
  clientOptions = [],
  stageOptions,
  hasActiveFilters,
}) => {
  return (
    <DealsFiltersBar
      searchValue={filters.searchTerm}
      onSearchChange={onSearchChange}
      searchPlaceholder="Cerca per nome, cliente, responsabile..."
      hasActiveFilters={hasActiveFilters}
      onReset={onClearFilters}
      filters={[
        {
          id: 'priority',
          value: filters.priorityFilter,
          onChange: onPriorityChange,
          placeholder: 'Priorità',
          options: [
            { value: 'all', label: 'Tutte le priorità' },
            { value: 'alta', label: 'Alta' },
            { value: 'media', label: 'Media' },
            { value: 'bassa', label: 'Bassa' },
          ],
        },
        {
          id: 'client',
          value: filters.clientFilter,
          onChange: onClientChange,
          placeholder: 'Cliente',
          options: [
            { value: 'all', label: 'Tutti i clienti' },
            ...clientOptions,
          ],
        },
        {
          id: 'assignee',
          value: filters.assigneeFilter,
          onChange: onAssigneeChange,
          placeholder: 'Responsabile',
          options: [
            { value: 'all', label: 'Tutti i responsabili' },
            ...assigneeOptions.map((assignee) => ({
              value: assignee,
              label: assignee,
            })),
          ],
        },
        {
          id: 'stage',
          value: filters.stageFilter,
          onChange: onStageChange,
          placeholder: 'Fase',
          options: [
            { value: 'all', label: 'Tutte le fasi' },
            ...stageOptions.map((stage) => ({
              value: stage,
              label: stage,
            })),
          ],
        },
      ]}
    />
  );
};

export default ProposalFilters;
